import { InvalidInputError, readSheet, SheetNotFoundError } from 'read-excel-file/browser';

import type { Cell } from './cells';
import { parseSheet, type ParsedSheet } from './parse-sheet';

// Lee el Excel subido: la hoja "Documentos" de la plantilla o, si la renombraron, la
// primera. Un archivo que no es Excel se explica en vez de fallar en silencio.

export async function readImportFile(file: File): Promise<ParsedSheet> {
  try {
    let data: Cell[][];
    try {
      data = (await readSheet(file, 'Documentos')) as Cell[][];
    } catch (err) {
      if (!(err instanceof SheetNotFoundError)) {
        throw err;
      }
      data = (await readSheet(file)) as Cell[][];
    }
    return parseSheet(data);
  } catch (err) {
    if (err instanceof InvalidInputError || err instanceof SheetNotFoundError) {
      return {
        rows: [],
        rowNumbers: [],
        problems: [
          {
            row: null,
            column: null,
            message:
              'El archivo no es un Excel válido (.xlsx). Guárdalo como Libro de Excel y súbelo de nuevo.',
          },
        ],
      };
    }
    throw err;
  }
}
